module.exports = __webpack_public_path__ + "static/media/KaTeX_Fraktur-Bold.7a3757c0.woff2";